import { Button } from '@usitsdasdesign/dds-react';
import Footer from 'molecules/Footer';
import { useSession } from 'next-auth/react';
import { useRouter } from'hooks/navigation-router-with-loading'
import { useEffect } from 'react';
import { updateImpersonationService } from 'services/impersonation.service';
import useSessionStore from 'store/sessionStore';

function LayoutMainContainer({ children }) {
    const { endSession, setEndSession } = useSessionStore();
    const { data: session, update } = useSession();

    const router = useRouter();
    async function onEndSession() {
        await updateImpersonationService();
        setEndSession({ show: false });
        update({
            logoutOnBehalf: true
        });

        setTimeout(() => {
            router.push('/');
            router.refresh();
        }, 300);
    }

    useEffect(() => {
        if (session?.impersonatingUserId) {
            setEndSession({ show: true, color: 'green' });
        }
    }, [session]);

    const borderColor = {
        green: 'border-green-900',
        blue: 'border-blue-900'
    };

    return (
        <div className={`relative min-h-[calc(100vh-3rem)] ${endSession.show && `end-session-enabled border-x-4 ${borderColor[endSession.color]}`}`}>
            {
                endSession.show && (
                    <div className="sticky top-[52px] right-0 z-50 flex justify-end w-fixt ml-auto">
                        <Button
                            label='Back to My Profile'
                            icon='close__l__stroke'
                            size='s'
                            className="absolute right-0"
                            onClick={onEndSession}
                            color={endSession?.color === 'green' ? 'green' : 'blue'}
                        />
                    </div>
                )
            }
            {children}
            <Footer/>
        </div>
    );
}

export default LayoutMainContainer;
